import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import {Link} from 'react-router';
import Radium, { StyleRoot } from 'radium';
import * as TgccRequest from '../tgccRequest';
import {TgccLogo} from './TgccLogo';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import { Whitelists } from 'mandrill-api';


const container : React.CSSProperties = {
    display:'flex',
    flexDirection:'column',
    marginTop:'50px'
}
const viewDesigns: React.CSSProperties = {
    backgroundColor:'#040A5E',
    color:'white',
    borderRadius:'20px',
    width:'268px',
    height:'42px',
    display:'flex',
    justifyContent:'center',
    padding:'10px',
    margin:'20px auto',
    cursor:'pointer',
    alignItems:'center',
    border:'none',
    ':hover':{
        backgroundColor:'white',
        border:'1px solid #040A5E',
        color:'#040A5E'

    }
}
const grad: React.CSSProperties = {
    width:'420px',
    height:'190px',
    color:'#3A54B4',
    fontFamily:'Lulo',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    backgroundColor:'#F0F0F0',
    borderRadius:'15px',
    marginTop:'25px',
    fontSize:'18px',
    cursor:'pointer',
    ':hover':{
        backgroundImage:'url(' + Tgcc.ResolveUrl('~/images/Graduation_Designs-01.png') + ')',
        backgroundRepeat:'no-repeat',
        width:'420px',
        height:'190px',
        backgroundSize:'cover',
        color:'transparent',
        backgroundPosition:'center'
    }
}
const camps:React.CSSProperties = {
    width:'420px',
    height:'190px',
    color:'#3A54B4',
    fontFamily:'Lulo',
    justifyContent:'center',
    alignItems:'center',
    backgroundColor:'#F0F0F0',
    borderRadius:'15px',
    display:'flex',
    marginTop:'25px',
    fontSize:'18px',
    cursor:'pointer',
    ':hover':{
        backgroundImage:'url(' + Tgcc.ResolveUrl('~/images/Camps_Designs-01.png') + ')',
        backgroundRepeat:'no-repeat',
        width:'420px',
        height:'190px',
        backgroundSize:'cover',
        color:'transparent',
        backgroundPosition:'center'
    }
}
const hospital:React.CSSProperties = {
    width:'420px',
    height:'190px',
    color:'#3A54B4',
    fontFamily:'Lulo',
    justifyContent:'center',
    alignItems:'center',
    backgroundColor:'#F0F0F0',
    borderRadius:'15px',
    display:'flex',
    marginTop:'25px',
    fontSize:'18px',
    cursor:'pointer',
    ':hover':{
        backgroundImage:'url(' + Tgcc.ResolveUrl('~/images/Hospital_Designs-01.png') + ')',
        backgroundRepeat:'no-repeat',
        width:'420px',
        height:'190px',
        backgroundSize:'cover',
        color:'transparent',
        backgroundPosition:'center'
    }
}
const church:React.CSSProperties = {
    width:'420px',
    height:'190px',
    color:'#3A54B4',
    fontFamily:'Lulo',
    justifyContent:'center',
    alignItems:'center',
    backgroundColor:'#F0F0F0',
    borderRadius:'15px',
    display:'flex',
    marginTop:'25px',
    fontSize:'18px',
    cursor:'pointer',
    ':hover':{
        backgroundImage:'url(' + Tgcc.ResolveUrl('~/images/Church_Designs-01.png') + ')',
        backgroundRepeat:'no-repeat',
        width:'420px',
        height:'190px',
        backgroundSize:'cover',
        color:'transparent',
        backgroundPosition:'center'
    }
}
const landscape:React.CSSProperties = {
    width:'420px',
    height:'190px',
    color:'#3A54B4',
    fontFamily:'Lulo',
    justifyContent:'center',
    alignItems:'center',
    backgroundColor:'#F0F0F0',
    borderRadius:'15px',
    display:'flex',
    marginTop:'25px',
    fontSize:'18px',
    cursor:'pointer',
    ':hover':{
        backgroundImage:'url(' + Tgcc.ResolveUrl('~/images/Landscaping_Designs-01.png') + ')',
        backgroundRepeat:'no-repeat',
        width:'420px',
        height:'190px',
        backgroundSize:'cover',
        color:'transparent',
        backgroundPosition:'center'
    }
}
const rest:React.CSSProperties = {
    width:'420px',
    height:'190px',
    color:'#3A54B4',
    fontFamily:'Lulo',
    justifyContent:'center',
    alignItems:'center',
    backgroundColor:'#F0F0F0',
    borderRadius:'15px',
    display:'flex',
    marginTop:'25px',
    fontSize:'18px',
    cursor:'pointer',
    ':hover':{
        backgroundImage:'url(' + Tgcc.ResolveUrl('~/images/Rest_Designs-01.png') + ')',
        backgroundRepeat:'no-repeat',
        width:'420px',
        height:'190px',
        backgroundSize:'cover',
        color:'transparent',
        backgroundPosition:'center'
    }
}
const startedDiv: React.CSSProperties = {
    display:'flex',
    flexDirection:'column',
    justifyContent:'center',
    alignItems:'center',
    color:'#3A54B4',
    fontSize:'16px',
    marginTop:'25px'
}
const lets: React.CSSProperties = {
    fontFamily:'Lulo',
    fontSize:'38px',
    color:'#3A54B4'
}
const getBtns: React.CSSProperties = {
    display:'flex',
    flexWrap:'wrap',
    width:'66%',
    justifyContent:'space-around',
    margin:'auto'
}
class _MajorAccountsGetStarted extends React.Component < Tgcc.BaseProps, any > {

    openDesigns = ()=>{return browserHistory.push(Tgcc.Routes.MajorAccountsDesignListView)}
    openGrad = ()=>{return browserHistory.push(Tgcc.Routes.MajorAccountsKeyword('graduation'))}
    openCamps= ()=>{return browserHistory.push(Tgcc.Routes.MajorAccountsDesignCat('Camps'))}

    openHospitals = ()=>{return browserHistory.push(Tgcc.Routes.MajorAccountsKeyword('hospital'))}

    openChurch = ()=>{return browserHistory.push(Tgcc.Routes.MajorAccountsDesignCat('Churches'))}

    openLand = ()=>{return browserHistory.push(Tgcc.Routes.MajorAccountsKeyword('business'))}

    openRest = ()=>{return browserHistory.push(Tgcc.Routes.MajorAccountsKeyword('food'))}


    render() {
        return (
            <div style={container} className="letsGetCont">
                <div style={startedDiv}>
                    <div style={lets} className="letsGet">LET'S GET STARTED</div>
                    <div>Ready to begin your order?</div>
                    <div>Click on any of the categories below to browse specific</div>
                    <div>designs for your event or industry!</div>
                </div>
                <div style={getBtns}>
                    <div style={grad} key={1} onClick={this.openGrad}>GRADUATION</div>
                    <div style={camps} key={2} onClick={this.openCamps}>CAMPS</div>
                    <div style={hospital} onClick={this.openHospitals} key={3}>HOSPITALS</div>
                    <div style={church} onClick={this.openChurch} key={4}>CHURCHES</div>
                    <div style={landscape} onClick={this.openLand} key={5}>LANDSCAPERS</div>
                    <div style={rest} onClick={this.openRest} key={6}>RESTAURANTS</div>
                </div>
                <div style={viewDesigns} key={7} onClick={this.openDesigns}>OR VIEW ALL DESIGNS HERE</div>
            </div>
        )

    }
    
}
const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { 
        state: state
    };
};

export var MajorAccountsGetStarted = connect(mapStateToProps)(Radium(_MajorAccountsGetStarted));